export default __webpack_public_path__ + "static/media/i-send.cf4b2fb6.svg";